



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Counter extends Vue {
  public currentValue: number = 0;
  public value: number = 1;
  public decrementDisabled = false;
  public incrementDisabled = false;

  @Prop()
  max: number = 20;

  @Prop()
  label: string | undefined;

  @Prop()
  step: number = 1;

  increment() {
    let newVal = this.currentValue + this.step;
    this.decrementDisabled = false;
    this.updateValue(newVal);
  }

  decrement() {
    let newVal = this.currentValue - this.step;
    this.incrementDisabled = false;
    this.updateValue(newVal);
  }

  blurHandler(n: any) {
    const blurVal: number = n.srcElement.value;

    this.updateValue(blurVal);
  }

  updateValue(newVal: number) {
    const oldVal = this.currentValue;

    if (oldVal === newVal || typeof this.value !== 'number') {
      return;
    }
    if (newVal <= 0) {
      newVal = 0;
      this.decrementDisabled = true;
    }
    if (newVal >= this.max) {
      newVal = this.max;
      this.incrementDisabled = true;
    }
    this.currentValue = newVal;
    this.$emit('input', this.currentValue);
  }
}
